'use strict';
var elements = document.querySelectorAll('.population');
var total = 0;
elements.forEach(function(el) {
    var num = Number(el.textContent.replace(/,/g, ''));
    total += num;
});
var average = Math.round(total / elements.length);
var averageEl = document.querySelector('.average-population');
var totalEl = document.querySelector('.total-population');
averageEl.textContent = average.toLocaleString();
totalEl.textContent = total.toLocaleString();

//# sourceMappingURL=js_get_data_DOM.0c823b93.js.map
